/* eslint-disable no-nested-ternary */
import { alpha } from '@mui/material/styles';
import { grey } from '../theme/palette';

export const recepientsRadioStyle = {
    display: 'flex',
    flexDirection: 'column',
    margin: '12px 0 0',
    gap: 1.5
};
export const recepientsSaveButtonStyle = (value) => ({
    width: '114px',
    marginTop: 3,
    display: 'block',
    bgcolor: 'transparent !important',
    border: value === '' ? `1px solid ${alpha(grey[500], 0.24)}` : '1px solid rgba(0, 171, 85, 0.48)',
    borderRadius: '8px',
    color: value !== '' && '#00AB55',
    boxShadow: 'none'
});
export const chipLabelStyle = (isLight) => ({
    mr: '16px',
    height: '24px',
    bgcolor: alpha(grey[500], 0.16),
    color: isLight ? grey[800] : '#fff',
    fontSize: '14px',
    mt: '3px',
    mb: '3px',
    '&:hover': {
        bgcolor: alpha(grey[500], 0.16)
    }
});
export const statusTypoStyle = (status) => ({
    bgcolor: status === 'DRAFT' ? alpha(grey[500], 0.16) : status === 'SCHEDULED' ? alpha('#FFC107', 0.16) : status === 'SENT' ? alpha('#54D62C', 0.16) : status === 'CANCELLED' ? alpha('#FF4842', 0.16) : status === 'SENDING' ? alpha('#FFC107', 0.16) : status === 'PAUSED' ? alpha('#1890FF', 0.16) : alpha('#1890FF', 0.16),
    padding: '5px 10px',
    color: status === 'DRAFT' ? grey[600] : status === 'SCHEDULED' ? '#B78103' : status === 'SENT' ? '#229A16' : status === 'CANCELLED' ? '#B72136' : status === 'SENDING' ? '#B78103' : '#0C53B7',
    lineHeight: '20px',
    borderRadius: '6px',
    fontWeight: 600,
    textTransform: 'capitalize'
});
export const statusTypoStyleForChannel = (status) => ({
    bgcolor: status === 'SMS' ? alpha(grey[500], 0.16) : status === 'EMAIL' ? alpha('#1890FF', 0.16) : status === 'WHATSAPP' ? alpha('#54D62C', 0.16) : status === 'CANCELLED' ? alpha('#FF4842', 0.16) : status === 'SENDING' ? alpha('#FFC107', 0.16) : status === 'PAUSED' ? alpha('#1890FF', 0.16) : alpha('#1890FF', 0.16),
    padding: '5px 10px',
    color: status === 'SMS' ? grey[600] : status === 'EMAIL' ? '#0C53B7' : status === 'WHATSAPP' ? '#229A16' : status === 'CANCELLED' ? '#B72136' : status === 'SENDING' ? '#B78103' : '#0C53B7',
    lineHeight: '20px',
    borderRadius: '6px',
    fontWeight: 600,
    textTransform: 'capitalize',
    textAlign: "center"
});
export const noDataTypoStyle = (isLight) => ({
    textAlign: 'center',
    width: '100%',
    color: isLight ? grey[800] : '#fff',
    fontSize: '18px',
    fontWeight: '700',
    mb: '8px',
    mt: '10px'
});

export const statusTypoCampaignStyle = (status) => ({
    bgcolor: status === 'DRAFT' ? alpha(grey[500], 0.16) : status === 'SCHEDULED' ? alpha('#FFC107', 0.16) : status === 'SENT' ? alpha('#54D62C', 0.16) : status === 'CANCELLED' ? alpha('#FF4842', 0.16) : status === 'SENDING' ? alpha('#FFC107', 0.16) : alpha('#1890FF', 0.16),
    padding: '5px 10px',
    color: status === 'DRAFT' ? grey[600] : status === 'SCHEDULED' ? '#B78103' : status === 'SENT' ? '#229A16' : status === 'CANCELLED' ? '#B72136' : status === 'SENDING' ? '#B78103' : '#0C53B7',
    borderRadius: '6px',
    textTransform: 'capitalize',
    lineHeight: '26px',
    fontSize: '14px',
    fontWeight: 700
});

export const dotStyle = (status) => ({
    width: '10px',
    height: '10px',
    borderRadius: '100%',
    backgroundColor: status === 'DRAFT' ? grey[600] : status === 'SCHEDULED' ? '#B78103' : status === 'SENT' ? '#229A16' : status === 'CANCELLED' ? '#B72136' : status === 'SENDING' ? '#B78103' : '#0C53B7',
    display: 'inline-block',
    marginRight: '8px'
});

export const previewButtonBoxStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: '16px 24px 0',
};

export const tagChipStyle = {
    marginRight: '8px',
    fontSize: '14px',
    fontWeight: 400,
    bgcolor: alpha(grey[500], 0.16),
    border: 0,
    height: '24px'
};

export const editDurationCardStyle = {
    boxShadow: 'none',
    p: 0,
    bgcolor: 'transparent',
    borderRadius: 0,
    mb: 0
};

export const dateTimeTextStyle = (type) => ({
    fontSize: '18px',
    fontWeight: '700',
    mb: '12px',
    display: type === 'CampaignPreviewPopup' ? 'none' : 'block'
});

export const targetAudienceTextStyle = {
    color: grey[600],
    fontSize: '14px',
    marginRight: '8px',
    fontWeight: '700'
};
